import { ComponentModuleLoader } from "../../../../common/types/Data/ComponentModuleLoader";
import { PagePost } from "../../../../common/Facebook/PagePost";
import { FacebookGalleryBaseModule } from "./FacebookGalleryBaseModule";
import { FacebookGalleryPopupModule } from "./FacebookGalleryPopupModule";

export const moduleLoader: ComponentModuleLoader<PagePost> = {
    baseModule: FacebookGalleryBaseModule,
    popupModule: FacebookGalleryPopupModule,
    payloadExtractor: (entity) => {
        return {
            entity,
        };
    },
    getSocialTags: (entity) => {
        return {
            description: entity.linkedContent.message,
            name: entity.linkedContent.message,
            previewImage: undefined,
        };
    },
};
